import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import VueNoty from "vuejs-noty";
import VueSweetalert2 from "vue-sweetalert2";
import moment from "moment";
import VueRouter from "vue-router";

//import VeeValidate from "vee-validate";
//import { ValidationProvider, extend, VeeValidate } from 'vee-validate';
//import { required } from "vee-validate/dist/rules";
import JwtService from "@/services/jwt.service";
import ApiService from "@/services/api.service";
import ModuleAccessService from "@/services/access-module.service";
import { CHECK_AUTH } from "@/store/modules/actions.type";
import { state } from "./store/modules/employee";

ApiService.init();

export const EventBus = new Vue();

Vue.config.productionTip = false;

Vue.use(VueNoty, {
  theme: "semanticui",
  layout: "topCenter",
  progressBar: false
});
Vue.use(VueSweetalert2);
Vue.use((moment.suppressDeprecationWarnings = true));

//Vue.use(VeeValidate);

Vue.filter("formatTime", function(value) {
  if (!value) return "";
  let appended_date = "01-01-1990";
  return moment(appended_date + "," + value).format("LT");
});

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MMMM Do YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("YYYY-MM-DD hh:mm");
  }
});

Vue.filter("formatShortDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY");
  }
});

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch(CHECK_AUTH)]).then(() => {
    if (to.meta.requiresAuth) {
      if (JwtService.getToken()) {
        if (
          ModuleAccessService.isFirstLOgIn() == null ||
          (!ModuleAccessService.isFirstLOgIn() && to.name == "home")
        ) {
          next({
            name: "change-password",
            params: { user_id: ModuleAccessService.getUserID() }
          });
        } else if (
          ModuleAccessService.getAppCode() == 201 &&
          to.name == "home"
        ) {
          next({ name: "insurance" });
        } else if (
          ModuleAccessService.getAppCode() == 401 &&
          to.name == "home"
        ) {
          next({ name: "clinics" });
        } else if (
          ModuleAccessService.getAppCode() == 301 &&
          to.name == "home"
        ) {
          next({ name: "traffic" });
        } /* else if (
          ModuleAccessService.getAppCode() == 100 &&
          to.name == "home"
        ) {
          next({ name: "traffic" });
        }*/ else
          next();
      } else next({ name: "sign-in" });
    } else next();
  });
});

new Vue({
  router: router,
  store: store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
